import { get, trim } from 'lodash';

class Section {
  constructor() {
    this.sectionMap = {
      section: 'Id',
      section_desc: 'Description'
    };
  }

  map(sections) {
    if (sections === undefined) {
      return [];
    }
    let theSections = [];
    for (let x = 0; x < sections.length; x++) {
      let section = {};
      for (let p in this.screenMap) {
        section[p] = trim(get(sections[x], this.sectionMap[p]));
      }
      theSections.push(screen);
    }

    return theSections;
  }
}

export default Section;



// WEBPACK FOOTER //
// ./src/javascripts/lib/tessitura/REST/maps/Section.js